import { call, put, takeEvery } from 'redux-saga/effects'
import { privateFetch } from '../../../fetch'
import { generalDoFailure } from '../../../util/fetchFailure'

import {
  API_URL_PATH_KEG_COLLECTIONS,
  API_URL_PATH_KEG_COLLECTION_BOOKINGS,
} from '../../../../../constants'

import {
  deleteKegCollectionRequest,
  deleteKegCollectionSuccess,
  deleteKegCollectionFailure,
  saveEditedKegCollectionBooking,
} from './utils'

import { CLOSE_BOOKING_AFTER_KEG_COLLECTION_DELETION } from '../../../../actions/actionTypes'

function* closeBookingAfterKegCollectionDeletionWorker(action) {
  if (!action) return

  const { kegCollectionId, bookingData } = action.payload || {}

  if (!kegCollectionId || !bookingData?.id) {
    return
  }

  // Reuse existing delete status state / spinner for the modal
  yield put(deleteKegCollectionRequest())

  try {
    // 1) DELETE the keg collection request
    yield call(privateFetch, {
      path: `${API_URL_PATH_KEG_COLLECTIONS}/${kegCollectionId}`,
      method: 'DELETE',
    })

    // 2) PUT the updated booking (with bookingStatus = 'COMPLETED')
    const response = yield call(privateFetch, {
      path: `${API_URL_PATH_KEG_COLLECTION_BOOKINGS}/${bookingData.id}`,
      method: 'PUT',
      data: bookingData,
    })

    const bookingDetails = response.data

    yield put(deleteKegCollectionSuccess())
    yield put(saveEditedKegCollectionBooking(bookingDetails))
  } catch (error) {
    yield call(generalDoFailure, {
      error,
      action: deleteKegCollectionFailure(error),
    })
  }
}

export default [
  [
    takeEvery,
    CLOSE_BOOKING_AFTER_KEG_COLLECTION_DELETION,
    closeBookingAfterKegCollectionDeletionWorker,
  ],
]
